import { render } from "./ReminderStat.vue?vue&type=template&id=79b2723a&scoped=true"
import script from "./ReminderStat.vue?vue&type=script&lang=js"
export * from "./ReminderStat.vue?vue&type=script&lang=js"

import "./ReminderStat.vue?vue&type=style&index=0&id=79b2723a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b2723a"]])

export default __exports__